// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 815 ? "Documents" : chunkId) + "." + {"453":"9b41687b","630":"19cb56f0","815":"78d641d5","841":"053d11ec"}[chunkId] + ".chunk.js";
};